jQuery(function () {
  if (document.body.classList.contains("block-editor-page")) return;

  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  domReady(() => {
    whenGsapReady(() => {
      whenScrollReady(() => {
        initSideFrameSection();
      });
    });
  });

  function initSideFrameSection() {
    const blocks = document.querySelectorAll(".js-side-frame");
    if (!blocks.length) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (reduceMotion) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    blocks.forEach((block) => {
      if (block.dataset.sfsInit === "1") return;
      block.dataset.sfsInit = "1";

      const items = block.querySelectorAll(".js-sfs-item");
      const sides = block.querySelectorAll(".js-sfs-parallax"); // renamed to avoid conflicts
      const center = block.querySelector(".sfs__center");

      const strengthAttr = block.getAttribute("data-parallax");
      const strength = strengthAttr ? parseFloat(strengthAttr) : 260;

      // speed 0.8 => parallax delta ~20%
      const speedAttr = block.getAttribute("data-parallax-speed");
      const speed = speedAttr ? parseFloat(speedAttr) : 0.8;
      const factor = clamp(1 - speed, 0, 1); // 0.2 when speed=0.8

      // Center sides vertically by .sfs__center, not by the whole section
      const measureCenterMid = () => {
        if (!center) return;

        const blockRect = block.getBoundingClientRect();
        const centerRect = center.getBoundingClientRect();

        // midpoint of .sfs__center in px from top of section
        const mid = centerRect.top + centerRect.height / 2 - blockRect.top;

        block.style.setProperty("--sfs-center-mid", `${mid}px`);
      };

      const computeOffset = (progress) => {
        const p = clamp(progress, 0, 1);
        const t = (p - 0.5) * 2; // -1..1 across section
        return -(t * strength * factor);
      };

      const applyOffset = (progress) => {
        if (!sides.length) return;
        const off = computeOffset(progress);
        sides.forEach((side) =>
          side.style.setProperty("--sfs-offset", `${off}px`),
        );
      };

      // Fade-in items
      if (items.length) {
        gsap.set(items, { autoAlpha: 0, y: 18 });

        const vars = {
          autoAlpha: 1,
          y: 0,
          duration: 0.95,
          ease: "power3.out",
          stagger: 0.1,
          clearProps: "transform",
        };

        if (ScrollTrigger) {
          vars.scrollTrigger = {
            trigger: block,
            start: "top 75%",
            once: true,
            invalidateOnRefresh: true,
            onRefresh: () => measureCenterMid(),
          };
        }

        gsap.to(items, vars);
      }

      // If no sides, just center-measure and exit
      measureCenterMid();
      window.addEventListener("resize", measureCenterMid);

      if (!sides.length) return;

      // Parallax with ScrollTrigger if available
      if (ScrollTrigger) {
        const st = ScrollTrigger.create({
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
          onRefresh: (self) => {
            measureCenterMid();
            applyOffset(self.progress);
          },
          onUpdate: (self) => applyOffset(self.progress),
        });

        applyOffset(st.progress);
        return;
      }

      // Fallback without ScrollTrigger
      let ticking = false;

      const update = () => {
        ticking = false;

        measureCenterMid();

        const rect = block.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const total = rect.height + vh;
        const p = clamp((vh - rect.top) / total, 0, 1);

        applyOffset(p);
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      update();
    });
  }
});
